export const countriesAlias = [
  { country: 'Britain', country_id: 2635167 },
  { country: 'England', country_id: 2635167 },
  { country: 'Wales', country_id: 2635167 },
  { country: 'Scotland', country_id: 2635167 },
  { country: 'Northern Ireland', country_id: 2635167 },
  { country: 'Blighty', country_id: 2635167 },
]
